import { BLOCK_TYPES, FIELD_TYPES } from '@client/components/Block/constants'

export const defaultText = {
  question: 'Write your question here...',
  helpText: 'Give us your best ideas',
}

export const defaultSettings = {
  type: BLOCK_TYPES.FIELD,
  fieldType: FIELD_TYPES.LONG_TEXT,
  question: defaultText.question,
  isRequired: false,
  hasHelpText: false,
  helpText: defaultText.helpText,
}
